// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"6d3fa97a","40":"6d3fa97a","79":"bd4bed4b","105":"c1400bcd","118":"575fc641","131":"e45575b4","921":"5733c3e7","926":"ed696820"}[chunkId] + ".css";
};